<template>
  <div>
    <el-carousel height="800px" :interval="8000">
      <el-carousel-item class="no_select">
        <img src="https://synjonessite.oss-cn-beijing.aliyuncs.com/site/image/main01.jpg" alt="" class="carousel-img">
      </el-carousel-item>
      <el-carousel-item class="no_select">
        <img src="https://synjonessite.oss-cn-beijing.aliyuncs.com/site/image/main02.jpg" alt="" class="carousel-img">
      </el-carousel-item>
      <el-carousel-item class="no_select">
        <img src="https://synjonessite.oss-cn-beijing.aliyuncs.com/site/image/main03.jpg" alt="" class="carousel-img">
      </el-carousel-item>
      <el-carousel-item class="no_select">
        <img src="https://synjonessite.oss-cn-beijing.aliyuncs.com/site/image/main04.jpg" alt="" class="carousel-img">
      </el-carousel-item>
    </el-carousel>
    <!--主页正文-->
    <div style="width: 1200px; margin: 0 auto">
      <!--产品-->
      <div>
        <h1 class="text_title no_select"
            style="color: #4069F3;">
          产品设备
        </h1>
        <el-carousel height="400px" indicator-position="outside" :interval="5000">
          <el-carousel-item v-for="(count, i) in productPage" :key="count">
            <el-row>
              <HomeProduct v-if="productItems[i * 3] !== undefined" :productItem="productItems[i * 3]"></HomeProduct>
              <HomeProduct v-if="productItems[i * 3 + 1] !== undefined"
                           :productItem="productItems[i * 3 + 1]"></HomeProduct>
              <HomeProduct v-if="productItems[i * 3 + 2] !== undefined"
                           :productItem="productItems[i * 3 + 2]"></HomeProduct>
            </el-row>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!--下载-->
      <!--        <div>
                <h1 class="text_title no_select"
                    style="background-image: linear-gradient(92deg, #c21137 0%, #fff525 100%);">
                  资料下载
                </h1>
                <div style="width: 100%;box-shadow: 0 1px 10px rgba(21,21,41,.1);">
                  <HomeDownload v-for="count in 5" :key="count"></HomeDownload>
                  <div style="line-height: 60px;text-align: center">
                    <a href="#">查看更多 >>></a>
                  </div>
                </div>
              </div>-->
    </div>
  </div>
</template>

<script>
import HomeProduct from '@/views/home/HomeProduct'
import HomeDownload from '@/views/product/ProductDownload'
import { productHome } from '@/api/product'

export default {
  name: 'home',
  // eslint-disable-next-line vue/no-unused-components
  components: { HomeDownload, HomeProduct },
  data () {
    return {
      productItems: [], // 主页产品数据
      productPage: 0 // 主页产品篇数
    }
  },
  created () {
    this.getProductItems()
  },
  methods: {
    getProductItems () {
      productHome().then(res => {
        this.productItems = res.body
        this.productPage = Math.ceil(this.productItems.length / 3)
      })
    }
  }
}
</script>

<style scoped>
  .text_title {
    font-size: 36px;
    font-weight: 100;
    letter-spacing: -.05em;
    margin-top: 20px;
  }

  .no_select {
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .el-carousel__item {
    background-color: #fafafa;
    box-shadow: 0 1px 4px rgba(21, 21, 41, .1);
  }
</style>
